var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import { Text } from "@twilio-paste/text";
import { useUID } from "@twilio-paste/uid-library";
import { Label } from "@twilio-paste/label";
import { MediaObject, MediaBody, MediaFigure } from "@twilio-paste/media-object";
import { HelpText } from "@twilio-paste/help-text";
var SwitchContainer = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "SWITCH_CONTAINER",
      children,
      disabled,
      helpText,
      label,
      id,
      required = !1
    } = _b,
    props = __objRest(_b, ["element", "children", "disabled", "helpText", "label", "id", "required"]);
  let switchId = id || useUID(),
    helpTextId = useUID(),
    labelId = useUID();
  return React.createElement(MediaObject, __spreadProps(__spreadValues({}, props), {
    element,
    ref
  }), React.createElement(MediaFigure, {
    spacing: "space30"
  }, React.cloneElement(children, {
    id: switchId,
    labelId,
    helpTextId,
    disabled
  })), React.createElement(MediaBody, null, React.createElement(Label, {
    as: "div",
    htmlFor: switchId,
    marginBottom: "space0",
    disabled,
    ref,
    id: labelId,
    element: `${element}_LABEL`,
    required
  }, React.createElement(Text, {
    as: "span",
    color: "currentColor",
    fontWeight: "fontWeightMedium"
  }, label != null ? label : React.createElement(React.Fragment, null))), helpText ? React.createElement(HelpText, {
    element: `${element}_HELP_TEXT`,
    marginTop: "space0",
    id: helpTextId
  }, helpText) : null));
});
SwitchContainer.displayName = "SwitchContainer";
import * as React3 from "react";
import * as PropTypes3 from "prop-types";
var SWITCH_WIDTH = "2.375rem",
  SWITCH_HEIGHT = "1rem";
import * as React2 from "react";
import * as PropTypes2 from "prop-types";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { CheckboxCheckIcon } from "@twilio-paste/icons/esm/CheckboxCheckIcon";
import { useTheme } from "@twilio-paste/theme";
var getSwitchKnobTransformValue = (disabled, switchIsOn, isHovering) => {
    if (disabled) {
      if (disabled) {
        if (!switchIsOn) return "translate(0%)";
        if (switchIsOn) return "translateX(100%)";
      }
    } else {
      if (!switchIsOn && isHovering) return "translateX(5%)";
      if (switchIsOn && !isHovering) return "translateX(100%)";
      if (switchIsOn && isHovering) return "translateX(95%)";
    }
    return "translate(0%)";
  },
  SwitchKnob = React2.forwardRef((_a, ref) => {
    var _b = _a,
      {
        element,
        disabled = !1,
        switchIsOn,
        isHovering,
        height
      } = _b,
      props = __objRest(_b, ["element", "disabled", "switchIsOn", "isHovering", "height"]);
    let theme = useTheme(),
      SWITCH_PADDING = theme.space ? theme.space.space20 : "4px",
      transformValue = React2.useMemo(() => getSwitchKnobTransformValue(disabled, switchIsOn, isHovering), [disabled, switchIsOn, isHovering]);
    return React2.createElement(Box, {
      width: `calc(100% - ${SWITCH_PADDING})`,
      height: "100%",
      position: "absolute",
      transform: transformValue,
      transition: "transform .2s ease-in-out"
    }, React2.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
      "aria-disabled": disabled,
      element: `${element}_KNOB`,
      ref,
      height,
      width: height,
      transform: switchIsOn ? "translateX(-100%)" : "translateX(0%)",
      transition: "transform .2s ease-in-out",
      borderColor: "colorBorder",
      borderWidth: "borderWidth10",
      borderRadius: "borderRadiusCircle",
      backgroundColor: "colorBackgroundBody",
      boxShadow: "shadowLow",
      _disabled: {
        boxShadow: "none"
      }
    }), React2.createElement(Box, {
      display: "flex",
      height: "100%",
      alignItems: "center",
      justifyContent: "center",
      opacity: switchIsOn ? "1" : "0",
      transition: "opacity .2s ease-in-out, color .2s ease-in-out"
    }, React2.createElement(CheckboxCheckIcon, {
      decorative: !0,
      size: "sizeIcon05",
      element: `${element}_ICON`
    }))));
  });
SwitchKnob.displayName = "SwitchKnob";
SwitchKnob.propTypes = {
  disabled: PropTypes2.bool,
  element: PropTypes2.string,
  switchIsOn: PropTypes2.bool.isRequired,
  isHovering: PropTypes2.bool.isRequired,
  height: PropTypes2.string.isRequired
};
import { Box as Box2, safelySpreadBoxProps as safelySpreadBoxProps2 } from "@twilio-paste/box";
var styles = {
    backgroundColor: "colorBackgroundStronger",
    _checked_hover: {
      backgroundColor: "colorBackgroundPrimary",
      color: "colorTextLink"
    },
    _checked: {
      backgroundColor: "colorBackgroundPrimaryStronger",
      color: "colorTextLinkStronger"
    },
    _hover: {
      backgroundColor: "colorBackgroundStrongest",
      cursor: "pointer"
    },
    _disabled: {
      backgroundColor: "colorBackgroundStrong",
      color: "colorTextIcon",
      cursor: "not-allowed"
    },
    _focus: {
      boxShadow: "shadowFocus"
    }
  },
  Switch = React3.forwardRef((_a, ref) => {
    var _b = _a,
      {
        element = "SWITCH",
        id,
        labelId,
        helpTextId,
        disabled = !1,
        on = !1,
        onClick
      } = _b,
      props = __objRest(_b, ["element", "id", "labelId", "helpTextId", "disabled", "on", "onClick"]);
    let [switchIsOn, setSwitchIsOn] = React3.useState(on),
      [isHovering, setIsHovering] = React3.useState(!1),
      handleClick = React3.useCallback(() => {
        disabled || (setSwitchIsOn(!switchIsOn), onClick && onClick());
      }, [onClick, disabled, switchIsOn]),
      handleKeyDown = React3.useCallback(event => {
        (event.key === " " || event.key === "Enter") && setSwitchIsOn(prev => !prev);
      }, []);
    return React3.createElement(Box2, __spreadProps(__spreadValues(__spreadValues({}, safelySpreadBoxProps2(props)), styles), {
      as: "div",
      role: "switch",
      "aria-checked": switchIsOn,
      "aria-disabled": disabled,
      "aria-labelledby": labelId,
      "aria-describedby": helpTextId,
      element,
      id,
      ref,
      tabIndex: 0,
      outline: "none",
      position: "relative",
      display: "inline-block",
      boxSizing: "content-box",
      height: SWITCH_HEIGHT,
      width: SWITCH_WIDTH,
      overflow: "hidden",
      padding: "space10",
      borderColor: "colorBorder",
      borderWidth: "borderWidth10",
      borderRadius: "borderRadiusPill",
      transition: "background-color .2s ease-in-out, box-shadow .2s ease-in-out",
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      onMouseEnter: () => {
        setIsHovering(!0);
      },
      onMouseLeave: () => {
        setIsHovering(!1);
      }
    }), React3.createElement(SwitchKnob, {
      element,
      disabled,
      switchIsOn,
      isHovering,
      height: SWITCH_HEIGHT
    }));
  });
Switch.displayName = "Switch";
Switch.propTypes = {
  disabled: PropTypes3.bool,
  element: PropTypes3.string,
  labelId: PropTypes3.string,
  id: PropTypes3.string,
  on: PropTypes3.bool,
  onClick: PropTypes3.func
};
export { Switch, SwitchContainer };